module.exports = __webpack_public_path__ + "static/media/card.f0581a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/washington-dc/card.jpg
// module id = 909
// module chunks = 27